import { render } from "./jednaWiadomosc.vue?vue&type=template&id=399e159e&scoped=true"
import script from "./jednaWiadomosc.vue?vue&type=script&lang=js"
export * from "./jednaWiadomosc.vue?vue&type=script&lang=js"

import "./jednaWiadomosc.vue?vue&type=style&index=0&id=399e159e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399e159e"]])

export default __exports__